import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { CardInfoChange } from '../../components/person/CardInfoChange';
import { AddressChange } from 'components/person/AddressChange';

import { Pearl } from 'components/badges/Pearl';
import { Emerald } from 'components/badges/Emerald';
import { Ruby } from 'components/badges/Ruby';
import { Sapphire } from 'components/badges/Sapphire';
import { Diamond } from 'components/badges/Diamond';
import { Glampoints } from 'components/icons/Glampoints';

import Styles from 'views/pages/SobreGlamClub.module.scss';
import { GlamboxBadge } from 'core/glambox/GlamboxBadge';

class SobreGlamClub extends Component {
  badgeInfos = [
    {
      id: 1,
      icon: Pearl,
      name: 'Pérola',
      subtitle: '1 caixa recebida',
      text: 'O charme da pérola é seu e nós vamos te ajudar a aprimorar sua beleza a cada mês.',
    },
    {
      id: 2,
      icon: Emerald,
      name: 'Esmeralda',
      subtitle: '3 caixas recebidas',
      text: 'Você receberá 25% mais Glampoints para trocar por produtos no Glamclub.',
    },
    {
      id: 3,
      icon: Ruby,
      name: 'Ruby',
      subtitle: '6 caixas recebidas',
      text: 'Você receberá 50% mais Glampoints para trocar por produtos no Glamclub.',
    },
    {
      id: 4,
      icon: Sapphire,
      name: 'Safira',
      subtitle: '9 caixas recebidas',
      text: 'Você receberá 75% mais Glampoints para trocar por produtos no Glamclub.',
    },
    {
      id: 5,
      icon: Diamond,
      name: 'Diamante',
      subtitle: '12 caixas recebidas',
      text: 'Você receberá 100% mais Glampoints para trocar por produtos no Glamclub.',
    },
  ];

  renderBadgeList = () => {
    let { badge } = this.props.person;

    return this.badgeInfos.map((item, key) => {
      let Icon = item.icon,
        badgeSlug = GlamboxBadge.getJewelSlug(item.id),
        _cls = ['p-xl-4 p-3 d-flex flex-row flex-lg-column', Styles['wfull'], Styles[badgeSlug]],
        personBadgeSlug = badge ? GlamboxBadge.getJewelSlug(badge.badgeId) : null;

      if (personBadgeSlug === badgeSlug) _cls.push(Styles['isActive']);

      return (
        <div className={classnames(_cls)} key={key}>
          <Icon />
          <div>
            <b>{item.name}</b>
            <em>{item.subtitle}</em>
            <span>{item.text}</span>
          </div>
          <section>Sua joia</section>
        </div>
      );
    });
  };

  render() {
    return (
      <div className={'p-2 p-lg-5 sobre-glamclub'}>
        <Helmet>
          <title>Minha Glambox : Como Funciona</title>
        </Helmet>

        <h1>Como funciona o Glamclub</h1>

        <div
          className={
            'level-2 p-xl-5 p-3 d-flex justify-between align-items-center flex-column flex-lg-row bg-w'
          }
        >
          <p>
            Bem-vinda ao nosso clube de fidelidade exclusivo para Glamgirls. Aqui você pode trocar
            seus Glampoints, moeda da Glambox, por ainda mais produtos. Existem diversas maneiras de
            juntar os Glampoints e você poderá escolher os produtos que mais te agradam para receber
            a mais com a sua próxima edição.
          </p>
          <NavLink to={'/produtos'} className={'btn btn-md btn-light-lime text-no-wrap'}>
            Ir para vitrine
          </NavLink>
        </div>

        <div
          className={
            'level-2 d-flex justify-between align-items-center flex-column bg-w glampoints'
          }
        >
          <h3>Glampoints</h3>
          <div className={'d-flex flex-column flex-lg-row'}>
            <div className={'p-xl-4 p-3 wfull'}>
              <div className={'d-flex flex-column'}>
                <Glampoints size={64} />
                <strong>Até 100 Glampoints</strong>
              </div>
              <span>
                Você já recebeu seus primeiros glampoints só por assinar ou renovar a Glambox!
              </span>
            </div>
            <div className={'p-xl-4 p-3 wfull'}>
              <div className={'d-flex flex-column'}>
                <Glampoints size={64} />
                <strong>Até 30 Glampoints*</strong>
              </div>
              <span>
                Divulgando fotos das suas caixinhas no Instagram usando a # do mês. Ah, para isso
                dar certo, não esqueça de{' '}
                <NavLink to={'/dados-pessoais'} className={'linkAnchor'}>
                  linkar sua conta com a Glambox
                </NavLink>
              </span>
            </div>
            <div className={'p-xl-4 p-3 wfull'}>
              <div className={'d-flex flex-column'}>
                <Glampoints size={64} />
                <strong>Até 20 Glampoints</strong>
              </div>
              <span>
                Respondendo os feedbacks de produtos e feedbacks das edições todos os meses.
              </span>
            </div>
            <div className={'p-xl-4 p-3 wfull'}>
              <div className={'d-flex flex-column'}>
                <Glampoints size={64} />
                <strong>Até 200 Glampoints</strong>
              </div>
              <span>
                <NavLink to={'/chama-as-amigas'} className={'linkAnchor'}>
                  Chamando suas amigas
                </NavLink>{' '}
                para assinarem a Glambox
              </span>
            </div>
            <div className={'p-xl-4 p-3 wfull'}>
              <div className={'d-flex flex-column'}>
                <Glampoints size={64} />
                <strong>Até 30 Glampoints</strong>
              </div>
              <span>
                Participe das campanhas de hashtags da nossas marcas parceiras que divulgamos no
                nosso Instagram e, ainda, concorre aos sorteios para ganhar mais gifts.
                <NavLink to={'/ganhe-mais-glampoints'} className={'linkAnchor'}>
                  Veja as campanhas que estão rolando.
                </NavLink>
              </span>
            </div>
          </div>
          <div className={'p-2 glampoints_detail'}>
            <small>
              <b>
                *Os Glampoints podem ser creditados em até 20 dias após as ações sob análise do
                conteúdo pela Glambox.
              </b>
            </small>
          </div>
        </div>

        <div className={Styles['banner-title']}>
          <h3>Acumule Glampoints e Ganhe </h3>
        </div>

        <div id={Styles['cmgmGlamClub']}>
          <div className={Styles['linha']}>
            <img
              className={Styles['mobile']}
              src={'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_20977.png'}
              alt={'toda girlboss merece um'}
            />
            <img
              className={Styles['desktop']}
              src={'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_20977.png'}
              alt={'toda girlboss merece um'}
            />
            <div className={Styles['text-container']}>
              <br />
              <p>
                Quer um vale presente para usar como quiser e comprar vários produtinhos da
                Biossance? Então comece a juntar seus pontinhos!
              </p>
              <strong>
                As 10 Glamgirls que mais acumularem Glampoints esse mês levam um super prêmio!
              </strong>
              <small>
                *Válido de 01/11 a 30/11 | *Válidos apenas Glampoints adquiridos durante esse
                período |*O prêmio será enviado junto a sua edição do mês seguinte
              </small>
            </div>
          </div>
        </div>

        <div id="joias" className={classnames('level-2 bg-w', Styles['joias'])}>
          <h3>Benefícios das Joias</h3>
          <div className={'d-flex justify-between flex-column flex-lg-row'}>
            {this.renderBadgeList()}
          </div>
        </div>

        <div className={'level-2 bg-w notMb regras'}>
          <div>
            <h3>Regras</h3>
            <div className={'d-flex justify-between flex-column flex-lg-row'}>
              <div className={'p-xl-4 p-3 d-flex flex-column wfull'}>
                <svg width="129" height="90" viewBox="0 0 129 90">
                  <g transform="translate(-470 -453.154)">
                    <rect
                      width="21.008"
                      height="3.504"
                      transform="translate(484 507.649)"
                      fill="#99f4cd"
                    />
                    <rect
                      width="21.008"
                      height="3.504"
                      transform="translate(510.664 507.649)"
                      fill="#99f4cd"
                    />
                    <rect
                      width="21.008"
                      height="3.504"
                      transform="translate(537.328 507.649)"
                      fill="#99f4cd"
                    />
                    <rect
                      width="7.008"
                      height="3.504"
                      transform="translate(563.992 507.649)"
                      fill="#99f4cd"
                    />
                    <path d="M596,462.154v-4a2,2,0,0,0-2-2H475a2,2,0,0,0-2,2v4Z" fill="none" />
                    <path
                      d="M487.233,478.154a7.723,7.723,0,0,0,2.51-.391v-3.5h-2.8v1.354H488.1v1.017a3.173,3.173,0,0,1-.719.076,1.317,1.317,0,0,1-1.1-.477,2.2,2.2,0,0,1-.38-1.389,2.159,2.159,0,0,1,.42-1.427,1.461,1.461,0,0,1,1.188-.5,3.434,3.434,0,0,1,1.541.346l.555-1.377a4.9,4.9,0,0,0-.948-.293,5.564,5.564,0,0,0-1.157-.115,3.446,3.446,0,0,0-2.514.875,3.261,3.261,0,0,0-.9,2.447,3.486,3.486,0,0,0,.819,2.483A3.036,3.036,0,0,0,487.233,478.154Z"
                      fill="#747f8b"
                    />
                    <rect
                      width="1.737"
                      height="6.911"
                      transform="translate(490.964 471.154)"
                      fill="#747f8b"
                    />
                    <path
                      d="M495.161,478.154a2.375,2.375,0,0,0,.942-.16,1.975,1.975,0,0,0,.715-.6h.036l.333.667h1.2v-3.3a1.719,1.719,0,0,0-.53-1.342,2.158,2.158,0,0,0-1.5-.48,4.825,4.825,0,0,0-2.221.454l.5,1.145a3.677,3.677,0,0,1,1.4-.373.546.546,0,0,1,.613.622v.071l-.84.027a3.062,3.062,0,0,0-1.621.442,1.365,1.365,0,0,0-.56,1.2,1.665,1.665,0,0,0,.409,1.2A1.477,1.477,0,0,0,495.161,478.154Zm1.1-2.319.4-.018v.391a.665.665,0,0,1-.225.52.782.782,0,0,1-.539.2q-.493,0-.493-.462Q495.406,475.866,496.263,475.835Z"
                      fill="#747f8b"
                    />
                    <path
                      d="M505.741,472.943a1.971,1.971,0,0,0-.837.176,1.425,1.425,0,0,0-.593.486h-.138a1.7,1.7,0,0,0-1.528-.662,1.963,1.963,0,0,0-.863.183,1.29,1.29,0,0,0-.58.528h-.1l-.218-.622h-1.31v5.033h1.737v-2.2a2.793,2.793,0,0,1,.186-1.191.624.624,0,0,1,.6-.364.451.451,0,0,1,.431.255,1.716,1.716,0,0,1,.133.767v2.736H504.4v-2.346a2.338,2.338,0,0,1,.186-1.07.622.622,0,0,1,.586-.342.468.468,0,0,1,.442.255,1.637,1.637,0,0,1,.14.767v2.736h1.737v-3.274a1.974,1.974,0,0,0-.427-1.39A1.722,1.722,0,0,0,505.741,472.943Z"
                      fill="#747f8b"
                    />
                    <path
                      d="M512.573,477.709v-1.381a2.7,2.7,0,0,1-1.466.444q-.893,0-.893-1.208a1.6,1.6,0,0,1,.231-.928.752.752,0,0,1,.653-.329,1.864,1.864,0,0,1,.555.082,5.523,5.523,0,0,1,.582.22l.511-1.284a3.679,3.679,0,0,0-1.648-.382,2.774,2.774,0,0,0-2.01,4.544,2.473,2.473,0,0,0,1.872.667A2.859,2.859,0,0,0,512.573,477.709Z"
                      fill="#747f8b"
                    />
                    <rect
                      width="1.737"
                      height="6.911"
                      transform="translate(513.572 471.154)"
                      fill="#747f8b"
                    />
                    <path
                      d="M518.258,478.154a2.113,2.113,0,0,0,.913-.185,1.413,1.413,0,0,0,.606-.531h.1l.218.627h1.31v-5.033H519.67v2.2a2.678,2.678,0,0,1-.191,1.193.668.668,0,0,1-.639.353.483.483,0,0,1-.46-.253,1.584,1.584,0,0,1-.14-.746v-2.75H516.5v3.278a1.891,1.891,0,0,0,.462,1.362A1.707,1.707,0,0,0,518.258,478.154Z"
                      fill="#747f8b"
                    />
                    <path
                      d="M524.236,477.572h.107a2.057,2.057,0,0,0,.4.355,1.475,1.475,0,0,0,.389.167,1.919,1.919,0,0,0,.5.06,1.558,1.558,0,0,0,1.352-.7,4.026,4.026,0,0,0,.005-3.826,1.514,1.514,0,0,0-1.3-.689,1.6,1.6,0,0,0-.753.174,1.578,1.578,0,0,0-.584.564h-.062c.041-.456.062-.778.062-.964v-1.563h-1.737v6.911h1.355Zm.107-2.217a1.459,1.459,0,0,1,.169-.8.593.593,0,0,1,.533-.253q.652,0,.653,1.213a2.029,2.029,0,0,1-.165.921.511.511,0,0,1-.471.313.6.6,0,0,1-.55-.268,1.734,1.734,0,0,1-.169-.886Z"
                      fill="#747f8b"
                    />
                    <path
                      d="M594,453.154H475a5,5,0,0,0-5,5v80a5,5,0,0,0,5,5H594a5,5,0,0,0,5-5v-80A5,5,0,0,0,594,453.154Zm-119,3H594a2,2,0,0,1,2,2v4H473v-4A2,2,0,0,1,475,456.154Zm119,84H475a2,2,0,0,1-2-2v-74H596v74A2,2,0,0,1,594,540.154Z"
                      fill="#747f8b"
                    />
                    <rect
                      width="21.008"
                      height="21.008"
                      transform="translate(484 484.649)"
                      fill="#00e381"
                    />
                    <rect
                      width="21.008"
                      height="21.008"
                      transform="translate(510.664 484.649)"
                      fill="#00e381"
                    />
                    <rect
                      width="21.008"
                      height="21.008"
                      transform="translate(537.328 484.649)"
                      fill="#00e381"
                    />
                    <path
                      d="M571,489.455a2.636,2.636,0,0,1,4.5-1.865l9.5,9.5V484.649H563.992v21.008H571Z"
                      fill="#00e381"
                    />
                    <rect
                      width="21.008"
                      height="20.74"
                      transform="translate(484 517.649)"
                      fill="#00e381"
                    />
                    <rect
                      width="21.008"
                      height="20.74"
                      transform="translate(510.664 517.649)"
                      fill="#00e381"
                    />
                    <rect
                      width="21.008"
                      height="20.74"
                      transform="translate(537.328 517.649)"
                      fill="#00e381"
                    />
                    <path
                      d="M583.167,521.32a2.64,2.64,0,0,1-2.394-1.533l-.987-2.138h-2.938l-1.173,1.434a2.629,2.629,0,0,1-4.657-1.434h-7.026v20.74H585V520.765l-.795.341A2.57,2.57,0,0,1,583.167,521.32Z"
                      fill="#00e381"
                    />
                    <path
                      d="M574.085,489.006a.636.636,0,0,0-1.085.45v27.958a.636.636,0,0,0,1.127.4l5.076-6.2,3.387,7.338a.634.634,0,0,0,.577.368.616.616,0,0,0,.25-.052l4.448-1.906a.634.634,0,0,0,.326-.85l-3.4-7.358h7.9a.637.637,0,0,0,.45-1.086Z"
                      fill="#747f8b"
                    />
                  </g>
                </svg>
                <span>
                  Acesse o Glamclub, escolha o produto e troque os seus glampoints. Colocamos
                  produtos a toda hora. Vale a pena você entrar com frequência para verificar as
                  novidades!
                </span>
              </div>
              <div className={'p-xl-4 p-3 d-flex flex-column wfull'}>
                <svg width="129" height="90" viewBox="0 0 129 90">
                  <g transform="translate(-80.883 -299.136)">
                    <path
                      d="M142.287,330.056a11.558,11.558,0,0,1-2.753,7.746,15.671,15.671,0,0,1-7.962,4.7v.2q12.141,1.527,12.142,11.479a12.439,12.439,0,0,1-5.358,10.649Q133,368.705,123.477,368.7a43.522,43.522,0,0,1-7.248-.564,37.741,37.741,0,0,1-7.216-2.057V355.2a28.741,28.741,0,0,0,6.486,2.4,26.554,26.554,0,0,0,6.087.78q4.313,0,6.287-1.21a4.137,4.137,0,0,0,1.974-3.8,4.271,4.271,0,0,0-1.029-3.069,6.646,6.646,0,0,0-3.317-1.625,26.489,26.489,0,0,0-5.971-.548h-2.986v-9.853H119.6q9.985,0,9.985-5.108a3.138,3.138,0,0,0-1.476-2.854,7.39,7.39,0,0,0-3.964-.928,18.145,18.145,0,0,0-9.621,3.118l-5.441-8.758a26.424,26.424,0,0,1,7.88-3.782,34.4,34.4,0,0,1,9.239-1.128q7.53,0,11.81,2.986A9.494,9.494,0,0,1,142.287,330.056Z"
                      fill="#00e381"
                    />
                    <path d="M199.361,363.7l-10,10-10-10Z" fill="#00e381" />
                    <path d="M199.361,327.107l-10-10-10,10Z" fill="#00e381" opacity="0.4" />
                    <path d="M170.219,343.136h36.664v-39a2,2,0,0,0-2-2H170.219Z" fill="none" />
                    <path
                      d="M168.219,302.136H85.883a2,2,0,0,0-2,2v80a2,2,0,0,0,2,2h82.336Z"
                      fill="none"
                    />
                    <path d="M170.219,345.136v41h34.664a2,2,0,0,0,2-2v-39Z" fill="none" />
                    <path
                      d="M204.883,299.136h-119a5,5,0,0,0-5,5v80a5,5,0,0,0,5,5h119a5,5,0,0,0,5-5v-80A5,5,0,0,0,204.883,299.136Zm2,5v39H170.219v-41h34.664A2,2,0,0,1,206.883,304.136Zm-123,80v-80a2,2,0,0,1,2-2h82.336v84H85.883A2,2,0,0,1,83.883,384.136Zm121,2H170.219v-41h36.664v39A2,2,0,0,1,204.883,386.136Z"
                      fill="#747f8b"
                    />
                  </g>
                </svg>
                <span>
                  Saiba que as trocas são limitadas! Cada assinante pode fazer até 3 trocas no mês e
                  pode trocar apenas 1 vez o mesmo produto.
                </span>
              </div>
              <div className={'p-xl-4 p-3 d-flex flex-column wfull'}>
                <svg width="129" height="90" viewBox="0 0 129 90">
                  <g transform="translate(-445.84 -61.914)">
                    <path
                      d="M509.34,92.61v-27.7h-58.5a2,2,0,0,0-2,2v25.7ZM483.155,72.339h9.58v2.792h-3.079v9.848h-3.415V75.131h-3.086Zm-8.793,0h7.5v2.74h-4.089v1.989h3.787v2.741h-3.787v2.386h4.089v2.784h-7.5Zm-10.808,8.974a10.148,10.148,0,0,0,2.032.783,7.579,7.579,0,0,0,1.936.281,1.882,1.882,0,0,0,1.116-.264.811.811,0,0,0,.354-.679.742.742,0,0,0-.143-.454,1.636,1.636,0,0,0-.458-.393q-.315-.2-1.681-.813a8.052,8.052,0,0,1-1.855-1.089,3.334,3.334,0,0,1-.916-1.211,4.011,4.011,0,0,1-.3-1.616,3.241,3.241,0,0,1,1.271-2.724,5.607,5.607,0,0,1,3.493-.977,9.8,9.8,0,0,1,4,.908L471.361,75.7a7.581,7.581,0,0,0-3.06-.813,1.594,1.594,0,0,0-.969.234.7.7,0,0,0-.3.579.837.837,0,0,0,.384.666A14.757,14.757,0,0,0,469.5,77.44a5.776,5.776,0,0,1,2.27,1.578,3.423,3.423,0,0,1,.635,2.122,3.726,3.726,0,0,1-.6,2.088,3.9,3.9,0,0,1-1.721,1.418,6.363,6.363,0,0,1-2.637.506,10.686,10.686,0,0,1-2.118-.177,7.851,7.851,0,0,1-1.781-.618Z"
                      fill="none"
                    />
                    <path
                      d="M511.34,92.61h60.5v-25.7a2,2,0,0,0-2-2h-58.5Zm39.911-20.271h9.579v2.792h-3.077v9.848h-3.415V75.131h-3.087Zm-12.546,0h3.432v7.418a3.038,3.038,0,0,0,.5,1.945,2.164,2.164,0,0,0,3,0,3.221,3.221,0,0,0,.471-1.968v-7.4h3.415v7.608a5.1,5.1,0,0,1-1.4,3.843,5.589,5.589,0,0,1-4.051,1.362,5.531,5.531,0,0,1-3.972-1.323,5.005,5.005,0,0,1-1.388-3.8Zm-8.344-.2a5.989,5.989,0,0,1,4.574,1.651,6.826,6.826,0,0,1,1.556,4.851,6.822,6.822,0,0,1-1.564,4.85,7.113,7.113,0,0,1-9.144-.008,6.792,6.792,0,0,1-1.586-4.86,6.744,6.744,0,0,1,1.577-4.82A6.025,6.025,0,0,1,530.361,72.14Z"
                      fill="none"
                    />
                    <path
                      d="M530.344,82.307a2.19,2.19,0,0,0,1.923-.89,4.878,4.878,0,0,0,.627-2.775,4.929,4.929,0,0,0-.634-2.8,2.17,2.17,0,0,0-1.9-.9q-2.568,0-2.567,3.7Q527.794,82.308,530.344,82.307Z"
                      fill="none"
                    />
                    <path d="M511.34,94.61v54.3h58.5a2,2,0,0,0,2-2V94.61Z" fill="none" />
                    <path d="M509.34,94.61h-60.5v52.3a2,2,0,0,0,2,2h58.5Z" fill="none" />
                    <path
                      d="M467.453,85.152a6.363,6.363,0,0,0,2.637-.506,3.9,3.9,0,0,0,1.721-1.418,3.726,3.726,0,0,0,.6-2.088,3.423,3.423,0,0,0-.635-2.122,5.776,5.776,0,0,0-2.27-1.578,14.757,14.757,0,0,1-2.088-1.072.837.837,0,0,1-.384-.666.7.7,0,0,1,.3-.579,1.594,1.594,0,0,1,.969-.234,7.581,7.581,0,0,1,3.06.813l1.046-2.637a9.8,9.8,0,0,0-4-.908,5.607,5.607,0,0,0-3.493.977,3.241,3.241,0,0,0-1.271,2.724,4.011,4.011,0,0,0,.3,1.616,3.334,3.334,0,0,0,.916,1.211,8.052,8.052,0,0,0,1.855,1.089q1.365.615,1.681.813a1.636,1.636,0,0,1,.458.393.742.742,0,0,1,.143.454.811.811,0,0,1-.354.679,1.882,1.882,0,0,1-1.116.264,7.579,7.579,0,0,1-1.936-.281,10.148,10.148,0,0,1-2.032-.783v3.044a7.851,7.851,0,0,0,1.781.618A10.686,10.686,0,0,0,467.453,85.152Z"
                      fill="#747f8b"
                    />
                    <path
                      d="M481.866,82.2h-4.09V79.809h3.787V77.068h-3.787V75.079h4.09V72.339h-7.5V84.979h7.5Z"
                      fill="#747f8b"
                    />
                    <path
                      d="M486.241,84.979h3.415V75.131h3.078V72.339h-9.58v2.792h3.087Z"
                      fill="#747f8b"
                    />
                    <path
                      d="M525.783,83.484a7.113,7.113,0,0,0,9.144.008,6.822,6.822,0,0,0,1.564-4.85,6.826,6.826,0,0,0-1.556-4.851,7.158,7.158,0,0,0-9.161.013,6.744,6.744,0,0,0-1.577,4.82A6.792,6.792,0,0,0,525.783,83.484Zm4.578-8.543a2.17,2.17,0,0,1,1.9.9,4.929,4.929,0,0,1,.634,2.8,4.878,4.878,0,0,1-.627,2.775,2.19,2.19,0,0,1-1.923.89q-2.551,0-2.55-3.665Q527.794,74.94,530.361,74.941Z"
                      fill="#747f8b"
                    />
                    <path
                      d="M544.065,85.152a5.589,5.589,0,0,0,4.051-1.362,5.1,5.1,0,0,0,1.4-3.843V72.339h-3.415v7.4a3.221,3.221,0,0,1-.471,1.968,2.164,2.164,0,0,1-3,0,3.038,3.038,0,0,1-.5-1.945V72.339h-3.432v7.686a5.005,5.005,0,0,0,1.388,3.8A5.531,5.531,0,0,0,544.065,85.152Z"
                      fill="#747f8b"
                    />
                    <path
                      d="M554.338,84.979h3.415V75.131h3.077V72.339h-9.579v2.792h3.087Z"
                      fill="#747f8b"
                    />
                    <path
                      d="M569.84,61.914h-119a5,5,0,0,0-5,5v80a5,5,0,0,0,5,5h119a5,5,0,0,0,5-5v-80A5,5,0,0,0,569.84,61.914Zm2,5v25.7h-60.5v-27.7h58.5A2,2,0,0,1,571.84,66.914Zm-121-2h58.5v27.7h-60.5v-25.7A2,2,0,0,1,450.84,64.914Zm-2,82V94.61h60.5v54.3h-58.5A2,2,0,0,1,448.84,146.914Zm121,2h-58.5V94.61h60.5v52.3A2,2,0,0,1,569.84,148.914Z"
                      fill="#747f8b"
                    />
                    <path
                      d="M557.634,131.526l-8.6,3.171a.827.827,0,1,0,.573,1.551l8.6-3.171a.827.827,0,1,0-.573-1.551Z"
                      fill="#00e381"
                    />
                    <path
                      d="M546.675,135.569l-.364.135a.827.827,0,0,0,.286,1.6.842.842,0,0,0,.286-.051l.364-.135a.827.827,0,1,0-.572-1.551Z"
                      fill="#00e381"
                    />
                    <path
                      d="M558.7,128.647a.827.827,0,0,0-1.062-.489l-6.793,2.506a.827.827,0,0,0,.573,1.551l6.793-2.506A.827.827,0,0,0,558.7,128.647Z"
                      fill="#00e381"
                      opacity="0.5"
                    />
                    <path
                      d="M558.7,125.314a.827.827,0,0,0-1.062-.489l-6.793,2.506a.827.827,0,0,0,.573,1.551l6.793-2.506A.828.828,0,0,0,558.7,125.314Z"
                      fill="#00e381"
                      opacity="0.3"
                    />
                    <path
                      d="M559.635,111.306v1.128l.765-.282v21.886l-18.266,6.739V118.892l9.061-3.343v-1.762l-9.888,3.648-3.241-1.2,6.834-2.522a.827.827,0,0,0,0-1.551l-8.927-3.293a.827.827,0,0,0-.572,0l-8.649,3.191-2.976-1.1,17.531-6.469,7.68,2.834,1.287-1.287-8.681-3.2a.827.827,0,0,0-.572,0l-19.919,7.35h0a.845.845,0,0,0-.186.1.827.827,0,0,0-.354.678v23.648a.826.826,0,0,0,.54.775l19.919,7.35a.834.834,0,0,0,.286.051.823.823,0,0,0,.286-.052h0l19.92-7.35a.827.827,0,0,0,.54-.775V111.3c-.013,0-.024.006-.037.006Zm-23.948-.777,6.539,2.413-6.539,2.413-6.539-2.413Zm-8.1,3.605,7.273,2.684v8.829l-7.273-2.684Zm12.894,26.643-18.266-6.739V112.152l3.719,1.373v10.014a.828.828,0,0,0,.54.776l8.927,3.293a.807.807,0,0,0,.286.051.826.826,0,0,0,.826-.826v-9.4l3.968,1.464Z"
                      fill="#00e381"
                    />
                    <path
                      d="M562.25,109.493l-6.585-6.606a.33.33,0,0,0-.233-.1.334.334,0,0,0-.234.1l-6.6,6.606a.331.331,0,0,0,.234.564h3.617v8.251a.33.33,0,0,0,.33.33h5.28a.33.33,0,0,0,.33-.33v-8.251h3.631a.33.33,0,0,0,.234-.563Z"
                      fill="#00e381"
                    />
                    <path
                      d="M485.9,136.785a17.562,17.562,0,1,1,10.284-12.411,1.556,1.556,0,0,1,.208.768v5.542a20,20,0,1,0-8.283,7.824l-1.877-1.883C486.121,136.675,486.014,136.737,485.9,136.785Z"
                      fill="#e73332"
                    />
                    <path
                      d="M493.8,123.562a15.071,15.071,0,1,0-9.46,11.129,1.56,1.56,0,0,1-.327-.766,14.141,14.141,0,1,1,8.94-10.363Z"
                      fill="#e73332"
                      opacity="0.5"
                    />
                    <path d="M487.952,131.7c-.194.156-.4.3-.6.448h.6Z" fill="#e73332" />
                    <path
                      d="M483.836,122.3l-4.883,4.883-6.118-6.118,6.118-6.118,6.75,6.75.629-.632-6.641-6.641-.752-.744-.742.741h.006l-6.1,6.1-.54.541.316.316L478.2,127.7l.742.742.3-.3.024-.019,5.19-5.192.638-.638-.312-.312-5.108-5.108-.733-.733-.3.305-.013.011-4.285,4.286-.313.313.513.512,4.417,4.417.629-.633-4.3-4.295,3.655-3.655Z"
                      fill="#e73332"
                    />
                    <path
                      d="M498.759,133.393h-3.616v-8.251a.33.33,0,0,0-.33-.33h-5.281a.33.33,0,0,0-.33.33v8.251h-3.63a.33.33,0,0,0-.234.563l3.446,3.458.468.469,2.67,2.679a.331.331,0,0,0,.234.1.334.334,0,0,0,.234-.1l6.6-6.607a.33.33,0,0,0-.234-.563Z"
                      fill="#e73332"
                    />
                  </g>
                </svg>
                <span>
                  Os produtos são enviados junto com a edição do mês seguinte à troca. Por exemplo:
                  Se fizer uma ou mais trocas em 01 de Outubro os produtos serão enviados junto a
                  sua edição de Novembro.
                </span>
              </div>
            </div>
          </div>
          <div className={'p-xl-5 p-3 footer'}>
            Caso tenha alguma dúvida, consulte nosso{' '}
            <NavLink to={'/faq'} className={'linkAnchor'}>
              FAQ &gt;
            </NavLink>
          </div>
        </div>
      </div>
    );
  }

  getUrlKey = () => {
    let idToScroll = this.props.location;
    idToScroll.hash !== '' && this.scrollTo(idToScroll.hash.replace('#', ''));
  };

  scrollTo = (id) => {
    document.getElementById('gb-contents').scrollTo(0, document.getElementById(id).offsetTop);
  };

  componentDidMount() {
    this.getUrlKey();
  }
}

const mapStateToProps = (state) => ({
  person: state.person.data,
});

SobreGlamClub = connect(mapStateToProps)(SobreGlamClub);

export { SobreGlamClub };
